module.exports = __webpack_public_path__ + "static/zhenia_slobodianiuk-5c568d1b3119b38acfdc655604f21727.png";